/*
 * サブシステム名：取引先マスタ管理
 * 機能名：取引先マスタ一覧
 */
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

// import date from '@/ddv2.library/date'
import d2fmt from '@/ddv2.library/utils/formatter'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

import VTour from '@/components/DdCoachMark.vue'
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdListHeader from '@/components/DdListHeader'
import DdRadioButton from '@/components/DdRadioButton'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdTextBox from '@/components/DdTextBox'
import DdTransparentButton from '@/components/DdTransparentButton'
import CoachMark from './CoachMark/D2MSTT0025.js'

export default {
  name: 'MstTorihikisakiListEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdIconButtonWithTooltip,
    DdListHeader,
    DdRadioButton,
    DdSpreadSheet,
    DdTextBox,
    DdTransparentButton
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    newRowCount: 0,
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      torihikisakiCd: '',
      torihikisakiKbn: '0',
      tokuisakiFlg: true,
      shiiresakiFlg: true,
      hacchusakiFlg: true,
      torihikisakiNm: ''
    },

    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,

    modeKengen: 0,
    pageCount: 0,
    // ヘッダー定義
    headersEigyoshoList: header.mstEigyoshoHeaders,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '60vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },

    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }

      return false
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              torihikisakiCd: '',
              torihikisakiKbn: '0',
              tokuisakiFlg: false,
              shiiresakiFlg: false,
              hacchusakiFlg: false,
              torihikisakiNm: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          console.log('★★★', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstJininList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstJininList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.searchAction()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstJininList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstJininList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
              // self.onNewRowButtonClick()
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.rows = []
      this.$nextTick(() => {
        this.searchAction()
      })
    },
    searchAction: function (e) {
      this.selected = []
      this.newRowCount = 0
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.setSelectedKbn()
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstTorihikisaki/search', self.conditions)
              .then((data) => {
                self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload.map((elem) => {
            elem.tekiyoStartYmd = filter.dateFormatter(elem.tekiyoStartYmd)
            elem.tekiyoEndYmd = filter.dateFormatter(elem.tekiyoEndYmd)
            elem.hyojiOrder = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
            return elem
          })

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    setSelectedKbn: function () {
      const kbn = this.conditions.torihikisakiKbn
      this.conditions.tokuisakiFlg = kbn === '1'
      this.conditions.shiiresakiFlg = kbn === '2'
      this.conditions.hacchusakiFlg = kbn === '3'
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              torihikisakiCd: '',
              torihikisakiKbn: '0',
              tokuisakiFlg: false,
              shiiresakiFlg: false,
              hacchusakiFlg: false,
              torihikisakiNm: ''
            }
            this.searchText = ''
            this.rows = []
            this.page = 1
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    onMultiSaveButtonClick: function () {
      const self = this
      // 変更フラグONかつ発生年月日≠Nullのもののみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && !['', null, undefined].includes(elem.torihikisakiCd) && !['', null, undefined].includes(elem.torihikisakiNm) && !['', null, undefined].includes(elem.hyojiOrder)
      }).map((elem) => {
        // 取引先正式名称には取引先名称をセット
        elem.torihikisakiSeishikiNm = elem.torihikisakiNm
        return elem
      })
      if (saveTargetRow.length < 1) { return }

      // 数値変換
      saveTargetRow.map((elem) => {
        elem.id = [undefined, null, ''].includes(elem.id) ? -1 : elem.id
        elem.hyojiOrder = d2fmt.removeComma(elem.hyojiOrder)
        return elem
      })
      this.$nextTick(function () {
        self.saveAction(saveTargetRow)
      })
    },
    saveAction: function (data) {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.registerPromise(data)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.selected = []
            const dataList = data.payload
            dataList.map((elem) => {
              elem.editFlg = false
              elem.editMode = false
              elem.memo = ''

              elem.tekiyoStartYmd = filter.dateFormatter(elem.tekiyoStartYmd)
              elem.tekiyoEndYmd = filter.dateFormatter(elem.tekiyoEndYmd)
            })

            dataList.forEach(elem => {
              const tagetRow = self.rows.find(n => n.torihikisakiCd === elem.torihikisakiCd)
              if (tagetRow) {
                const index = this.rows.indexOf(tagetRow)
                // 取得データを差し替え
                elem.hyojiOrder = filter.numericFormatter(elem.hyojiOrder)
                Object.assign(this.rows[index], elem)
              }
            })

            self.rows.splice()
            self.Effects.loadComplete()

            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        },
        validateNotificationModeMethod: function () {
          return true
        },
        validateNotificationMethod: function () {
          const errList = self.$refs.ddSpreadSheet.errorList
          console.log('validateNotificationMethod', errList)
          if (errList.length > 0) {
            let errorMessages = ''
            errList.forEach(e => {
              let message = '<br>'
              message += `${e.y + 1}行目：${e.msg}`
              errorMessages += message
            })
            modals.showError(`入力内容に誤りがあります。${errorMessages}`)
          } else {
            modals.showToastMessage('COME0001', null, 600, null, null)
          }
        }
      }
      this.register(opt)
    },
    // 登録処理
    registerPromise: function (data) {
      console.log(' > registerPromise', data)
      this.Effects.loadStart()
      const l = this.HttpClient.put('/api/v1/mstTorihikisaki/BatchRegister', data)

      return l
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },

    /**
     * スプレッドシート制御
     * @returns
     */
    setHeader: function () {
      console.log('setHeader')
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        // const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        self.headers = [
          // ----------
          { title: '取引先コード', name: 'torihikisakiCd', type: 'text', validateType: 'AlphanumericWithSymbol', validateLength: 10, customInput: null, required: true, readOnly: false, width: '120px' },
          { title: '取引先名称', name: 'torihikisakiNm', type: 'text', validateType: 'Free', validateLength: 50, customInput: null, required: true, readOnly: false, width: '250px' },
          { title: '取引先名称カナ', name: 'torihikisakiNmKana', type: 'text', validateType: 'Free', validateLength: 50, customInput: null, readOnly: false, width: '250px' },
          { title: '郵便番号', name: 'yubinNo', type: 'text', validateType: 'AlphanumericWithSymbol', validateLength: 8, customInput: null, readOnly: false, width: '120px' },
          { title: '住所', name: 'jusho1', type: 'text', validateType: 'Free', validateLength: 100, customInput: null, readOnly: false, width: '450px' },
          { title: '荷主', name: 'tokuisakiFlg', type: 'checkbox', customInput: null, width: '60px' },
          { title: '傭車先', name: 'hacchusakiFlg', type: 'checkbox', customInput: null, width: '60px' },
          { title: '仕入先', name: 'shiiresakiFlg', type: 'checkbox', customInput: null, width: '60px' },
          // { title: '適用開始日', name: 'tekiyoStartYmd', type: null, customInput: 'date', validateType: 'Date', required: true, readOnly: false, width: '140px' },
          // { title: '適用終了日', name: 'tekiyoEndYmd', type: null, customInput: 'date', validateType: 'Date', required: true, readOnly: false, width: '140px' },
          { title: '表示順', name: 'hyojiOrder', type: null, customInput: 'numeric', customInputIntDigit: 6, customInputDecimalDigit: 0, readOnly: false, width: '100px', align: 'right' }
        ]
      })
    },
    rowAppend: function (num) {
      for (let i = 0; i < num; i++) {
        this.newRowCount = this.newRowCount - 1

        const newrow = {
          editFlg: false,
          memo: '',

          id: this.newRowCount,
          torihikisakiCd: null,
          torihikisakiKbn: '0',
          tokuisakiFlg: true,
          shiiresakiFlg: false,
          hacchusakiFlg: false,
          torihikisakiNm: null,
          torihikisakiNmKana: null,
          yubinNo: null,
          jusho1: null,
          tekiyoStartYmd: '2000/01/01',
          tekiyoEndYmd: '2999/12/31',
          hyojiOrder: '9,999'
        }
        this.rows.push(newrow)
      }
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },
    changeAfter: function (rowData, cell, x, y, newValue, oldValue) {
      console.log('ChangeAfter:', this.rows, rowData, cell, x, y, newValue, oldValue)

      if (newValue === oldValue) return

      if ([undefined, null].includes(rowData.id)) {
        this.newRowCount = this.newRowCount - 1
        const newrow = {
          editFlg: true,

          id: this.newRowCount,
          torihikisakiCd: newValue,
          torihikisakiNm: null,
          torihikisakiNmKana: null,
          torihikisakiKbn: '0',
          tokuisakiFlg: false,
          hacchusakiFlg: false,
          shiiresakiFlg: false,
          yubinNo: null,
          jusho1: null,
          tekiyoStartYmd: '2000/01/01',
          tekiyoEndYmd: '2999/12/31',
          hyojiOrder: '9,999'
        }
        this.rows.push(newrow)

        return
      }

      const recIndex = this.rows.findIndex(x => x.id === rowData.id)
      if (recIndex === -1) return

      const rec = this.rows[recIndex]
      rec.editFlg = true

      const keyMap = {
        0: 'torihikisakiCd',
        1: 'torihikisakiNm',
        2: 'torihikisakiNmKana',
        3: 'yubinNo',
        4: 'jusho1',
        5: 'tokuisakiFlg',
        6: 'hacchusakiFlg',
        7: 'shiiresakiFlg',
        8: 'hyojiOrder'
      }

      const key = keyMap[x]
      if (key) {
        rec[key] = newValue
      }
    },

    onNewRowButtonClick: function (e) {
      this.rowAppend(1)
    },

    onDummyFunction: function () {
      return null
    }
  }
}
